/**
 * Tenant-configured lists.
 *
 * Two audiences, two endpoints: `/api/data-sources` is what every operator
 * may see (enough to draw the nav and the table), `/api/settings/data-sources`
 * is the admin's configuration, and only it carries endpoints and queries.
 */
import type {
  CreateDataSourceBody,
  DataSource,
  DataSourceResult,
  DataSourceSummary,
  QueryDataSourceBody,
  UpdateDataSourceBody,
} from '@crm/contracts';
import { apiFetch } from './http';

export const dataSourcesApi = {
  /** The enabled lists, for the sidebar, the dashboard and the list page. */
  summaries: () => apiFetch<DataSourceSummary[]>('/api/data-sources'),

  run: (key: string, body: QueryDataSourceBody) =>
    apiFetch<DataSourceResult>(`/api/data-sources/${encodeURIComponent(key)}/query`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),

  all: () => apiFetch<DataSource[]>('/api/settings/data-sources'),

  create: (body: CreateDataSourceBody) =>
    apiFetch<DataSource>('/api/settings/data-sources', { method: 'POST', body: JSON.stringify(body) }),

  update: (key: string, body: UpdateDataSourceBody) =>
    apiFetch<DataSource>(`/api/settings/data-sources/${encodeURIComponent(key)}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),

  remove: (key: string) =>
    apiFetch<{ ok: boolean }>(`/api/settings/data-sources/${encodeURIComponent(key)}`, { method: 'DELETE' }),
};
